import { WDivider, WSkeleton, WStack } from '../../wrappers/wrapper';
import style from './view-profile-popover-skeleton.module.scss';

const ViewProfilePopoverSkeleton = () => {
  return (
    <WStack className={style.profilePopoverCard}>
      <WStack spacing={1.5} padding={'1.25rem'} justifyContent={'center'}>
        <WStack direction={'row'} alignItems={'start'} gap={2}>
          <WSkeleton animation="wave" variant="circular" width={96} height={96} />
          <WStack direction={'column'} alignItems={'start'}>
            <WSkeleton animation="wave" variant="text" width={120} height={40} />
            <WSkeleton animation="wave" variant="text" width={180} height={20} />
            <WSkeleton animation="wave" variant="text" width={150} height={20} />
          </WStack>
        </WStack>
        <WStack direction={'row'} gap={3} paddingTop={1}>
          <WSkeleton animation="wave" variant="text" width={60} height={40} />
          <WSkeleton animation="wave" variant="text" width={60} height={40} />
          <WSkeleton animation="wave" variant="text" width={60} height={40} />
          <WSkeleton animation="wave" variant="text" width={60} height={40} />
        </WStack>
        <WDivider />
        <WStack direction={'row'} gap={2} alignItems={'center'} paddingLeft={1}>
          <WSkeleton animation="wave" variant="circular" width={25} height={25} />
          <WSkeleton animation="wave" variant="rounded" width={200} height={15} />
        </WStack>
        <WStack direction={'row'} gap={2} alignItems={'center'} paddingBottom={3} paddingLeft={1}>
          <WSkeleton animation="wave" variant="rounded" width={25} height={25} />
          <WSkeleton animation="wave" variant="rounded" width={250} height={15} />
        </WStack>
        <WStack direction={'column'} gap={2}>
          <WSkeleton animation="wave" variant="rounded" width={40} height={20} />
          <WSkeleton animation="wave" variant="rounded" height={140} />
          <WSkeleton animation="wave" variant="rounded" width={60} height={20} />
          <WSkeleton animation="wave" variant="rounded" height={15} />
          <WSkeleton animation="wave" variant="rounded" width={60} height={20} />
          <WSkeleton animation="wave" variant="rounded" height={15} />
        </WStack>
      </WStack>
    </WStack>
  );
};

export default ViewProfilePopoverSkeleton;
